/**
 * DPO Payment Service
 * Handles communication with DPO payment gateway
 */
import axios from "axios";

export const initiateDPOPayment = async (paymentData) => {
  // Validate required fields
  const requiredFields = [
    "amount",
    "currency",
    "customerEmail",
    "customerFirstName",
    "customerLastName",
  ];

  for (const field of requiredFields) {
    if (!paymentData[field]) {
      console.error(`Missing required field: ${field}`, paymentData);
      return {
        success: false,
        message: `Missing required field: ${field}`,
      };
    }
  }

  try {
    // Format current date for ServiceDate (YYYY/MM/DD HH:MM)
    const now = new Date();
    const serviceDate = `${now.getFullYear()}/${String(
      now.getMonth() + 1
    ).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

    // Generate CompanyRef (unique transaction reference)
    const companyRef =  `ORD-${Date.now()}`;

    // Create ServiceDescription from selected modules or fallback
    const serviceDescription =
      paymentData.serviceDescription ||
      (paymentData.selectedModules && paymentData.selectedModules.length > 0
        ? `Registration for: ${paymentData.selectedModules.join(", ")}`
        : "Online Payment");

    const formData = new FormData();
    
    
    formData.append("amount", parseFloat(paymentData.amount).toFixed(2));
    formData.append("currency", paymentData.currency);
    formData.append("companyRef", 'REG-' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + '-' + Math.floor(1000 + Math.random() * 9000));
    formData.append("customerFirstName", paymentData.customerFirstName);
    formData.append("customerLastName", paymentData.customerLastName);
    formData.append("customerEmail", paymentData.customerEmail);
    formData.append('customerPhone', '+264811234567');
    formData.append('redirectURL', 'https://yourdomain.com/payment/success');
    formData.append('backURL', 'https://yourdomain.com/payment/cancel');
    formData.append("serviceType", paymentData.serviceType || "3854");
    formData.append("serviceDescription", serviceDescription);
    formData.append("serviceDate", serviceDate);
    // Log formData for debugging
    for (const [key, value] of formData.entries()) {
      //console.log(`FormData: ${key} = ${value}`);
    }

    // Make the API call to our backend
    const response = await axios.post(
      "https://mindsinaction.com.na/api/dpo/payment-proccess.php",

      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    // Check if the response status indicates success
    if (response.status >= 200 && response.status < 300) {
      const result = response.data;

      // If the backend returned an error
      if (!result.success) {
        console.error("Backend Error:", result);
        return {
          success: false,
          code: result.error || "UNKNOWN_ERROR",
          message: result.message || "Payment processing failed",
        };
      }

      // Return the successful response
      return {
        success: true,
        paymentUrl: `https://secure.3gdirectpay.com/dpopayment.php?ID=${result.token}`,
        token: result.token,
        companyRef: companyRef,
        transectionRef: result.transRef,
      };
    } else {
      console.error("HTTP Error:", response.status, response.statusText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error("DPO Payment Error:", error);
    return {
      success: false,
      message: error.message || "Failed to initiate payment",
    };
  }
};

/**
 * Utility function to redirect to DPO payment page
 */
export const redirectToDPOPayment = (paymentUrl) => {
  if (paymentUrl) {
    window.location.href = paymentUrl;
  } else {
    console.error("No payment URL provided");
  }
};